import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { Space, Table } from 'antd';
import { FC, useState } from 'react';

export const useCallReportAttendeeModal = () => {
	const [attendees, setAttendees] = useState<
		{
			id: number;
			prospectId: null;
			name: string;
			position: string;
			companyName: string;
			phoneNumber: string;
		}[]
	>([]);

	return {
		attendees,
		isOpen: attendees.length > 0,
		open: (data: typeof attendees) => setAttendees(data),
		close: () => setAttendees([]),
	};
};

type CallReportAttendeeModal = ReturnType<typeof useCallReportAttendeeModal>;

const CallReportAttendeeModal: FC<CallReportAttendeeModal> = (props) => {
	return (
		<FleetModal
			open={props.isOpen}
			width={940}
			cancelButtonProps={{
				hidden: true,
			}}
			buttonPosition="end"
			okText="BACK"
			closable={false}
			onOk={props.close}
		>
			<Space
				direction="vertical"
				style={{ display: 'flex' }}
				size={'large'}
			>
				<FleetTitle>Pihak Yang Hadir</FleetTitle>

				<Table
					bordered
					pagination={false}
					dataSource={
						props.attendees?.map((data, key) => {
							return {
								...data,
								key,
							};
						}) ?? []
					}
					columns={[
						{
							title: 'Nama',
							render: (_, record) => record.name,
						},
						{
							title: 'Jabatan',
							render: (_, record) => record.position,
						},
						{
							title: 'Nama Perusahaan',
							render: (_, record) => record.companyName,
						},
						{
							title: 'Nomor Telepon',
							render: (_, record) => record.phoneNumber,
						},
					]}
				/>
			</Space>
		</FleetModal>
	);
};

export default CallReportAttendeeModal;
